export default "__VITE_ASSET__D0HE4n6y__"